import styled from 'styled-components';

export const DataWithLoaderWrapper = styled.div``;
